( function( $ ) {
	'use strict';

	// Iterate over each image-caption pair
	$( '.image-caption__image' ).each( function() {
		const $imageWrap = $( this ),
			$image = $imageWrap.find( 'img' ),
			$caption = $imageWrap.next();

		// Set a max-width on the caption based on the width of the image when the image is fully loaded
		$image.on( 'load', function() {
			const imageWidth = $image.innerWidth();
			$caption.css( 'max-width', imageWidth + 'px' );
		} );

		// If the image is already cached, trigger the load event manually
		if ( $image[0].complete ) {
			$image.trigger( 'load' );
		}
	} );

} )( jQuery );
